import { Product } from '@@types'

export default function useCartItemTotal (
  product: Product,
  amount: number,
  oldPrice?: boolean,
) {
  const priceOffer = product.priceOffer

  if (!priceOffer) return null

  const price = oldPrice ? priceOffer.oldPrice : priceOffer.price
  const multiplier = priceOffer.count_multiplier || 1

  if (price == null) return null

  return (amount * price) / multiplier
}
